import type { StaticRouteLinkProps } from "./static-route-link.type";

import { Link } from "react-router";

import { useStaticRouteLink } from "./static-route-link.hook";

export const StaticRouteLink = ({
  route,
  search,
  customContext,
  children,
}: StaticRouteLinkProps) => {
  const options = { search, customContext };
  const link = useStaticRouteLink(route, options);

  return <Link to={link}>{children}</Link>;
};
